import GenericRequest, { METHOD_POST } from '../../../webservices/GenericRequest';
import { ApiEndpoints } from '../../../webservices/endpoint';

export class MessageSearchTask extends GenericRequest {

    _request; // MessageSearchRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.MESSAGES);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/message/list/message-search/MessageSearchTask.js